(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    (() => {

  const initializeGallery = (gallery) => {

    if (gallery.dataset.galleryInitialized === 'true') {
      return;
    }

    const slides = Array.from(
      gallery.querySelectorAll('[data-gallery-slide]')
    );

    const thumbs = Array.from(
      gallery.querySelectorAll('[data-gallery-thumb]')
    );

    const mobileThumbs = Array.from(
      gallery.querySelectorAll('[data-gallery-mobile-thumb]')
    );

    const thumbTrack = gallery.querySelector(
      '.custom-product-gallery__thumbs-track'
    );

    const mobileTrack = gallery.querySelector(
      '.custom-product-gallery__mobile-thumbs'
    );

    const previousButton = gallery.querySelector(
      '[data-gallery-prev]'
    );

    const nextButton = gallery.querySelector(
      '[data-gallery-next]'
    );

    if (!slides.length) return;

    gallery.dataset.galleryInitialized = 'true';

    let currentIndex = 0;

    /* ===================================
       SCROLL ACTIVE THUMBNAIL INSIDE
       ITS OWN TRACK ONLY.

       This avoids moving the page.
    =================================== */

    const revealThumbnail = (track, thumb, horizontal) => {

      if (!track || !thumb) return;

      if (horizontal) {

        const start = thumb.offsetLeft;
        const end = start + thumb.offsetWidth;

        const visibleStart = track.scrollLeft;
        const visibleEnd =
          visibleStart + track.clientWidth;

        if (start < visibleStart) {
          track.scrollTo({
            left: start,
            behavior: 'smooth'
          });
        } else if (end > visibleEnd) {
          track.scrollTo({
            left: end - track.clientWidth,
            behavior: 'smooth'
          });
        }

      } else {

        const start = thumb.offsetTop;
        const end = start + thumb.offsetHeight;

        const visibleStart = track.scrollTop;
        const visibleEnd =
          visibleStart + track.clientHeight;

        if (start < visibleStart) {
          track.scrollTo({
            top: start,
            behavior: 'smooth'
          });
        } else if (end > visibleEnd) {
          track.scrollTo({
            top: end - track.clientHeight,
            behavior: 'smooth'
          });
        }

      }

    };

    /* ===================================
       SHOW SELECTED PRODUCT MEDIA
    =================================== */

    const showSlide = (index) => {

      currentIndex =
        (index + slides.length) % slides.length;

      slides.forEach((slide, slideIndex) => {

        const active = slideIndex === currentIndex;

        slide.hidden = !active;
        slide.classList.toggle('is-active', active);

      });

      thumbs.forEach((thumb, thumbIndex) => {

        const active = thumbIndex === currentIndex;

        thumb.classList.toggle('is-active', active);

        thumb.setAttribute(
          'aria-current',
          active ? 'true' : 'false'
        );

      });

      mobileThumbs.forEach((thumb, thumbIndex) => {

        const active = thumbIndex === currentIndex;

        thumb.classList.toggle('is-active', active);

        thumb.setAttribute(
          'aria-current',
          active ? 'true' : 'false'
        );

      });

      /* Desktop active thumbnail */

      if (window.innerWidth >= 750) {

        revealThumbnail(
          thumbTrack,
          thumbs[currentIndex],
          false
        );

      } else {

        revealThumbnail(
          mobileTrack,
          mobileThumbs[currentIndex],
          true
        );

      }

    };

    /* ===================================
       DESKTOP THUMBNAIL CLICKS
    =================================== */

    thumbs.forEach((thumb, index) => {

      thumb.addEventListener('click', () => {
        showSlide(index);
      });

    });

    /* ===================================
       MOBILE THUMBNAIL CLICKS
    =================================== */

    mobileThumbs.forEach((thumb, index) => {

      thumb.addEventListener('click', () => {
        showSlide(index);
      });

    });

    /* ===================================
       PREVIOUS BUTTON
    =================================== */

    if (previousButton) {

      previousButton.addEventListener('click', () => {
        showSlide(currentIndex - 1);
      });

    }

    /* ===================================
       NEXT BUTTON
    =================================== */

    if (nextButton) {

      nextButton.addEventListener('click', () => {
        showSlide(currentIndex + 1);
      });

    }

    /* ===================================
       KEYBOARD NAVIGATION
    =================================== */

    gallery.addEventListener('keydown', (event) => {

      if (
        event.target.matches('input, textarea, select') ||
        event.target.isContentEditable
      ) {
        return;
      }

      if (event.key === 'ArrowLeft') {

        event.preventDefault();
        showSlide(currentIndex - 1);

      } else if (event.key === 'ArrowRight') {

        event.preventDefault();
        showSlide(currentIndex + 1);

      }

    });

    /* ===================================
       TOUCH SWIPE NAVIGATION
    =================================== */

    if (gallery.dataset.enableSwipe !== 'false') {

      const main = gallery.querySelector(
        '.custom-product-gallery__main'
      );

      let touchStartX = 0;
      let touchStartY = 0;

      if (main) {

        main.addEventListener('touchstart', (event) => {

          if (!event.touches.length) return;

          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;

        }, { passive: true });

        main.addEventListener('touchend', (event) => {

          if (!event.changedTouches.length) return;

          const differenceX =
            touchStartX - event.changedTouches[0].clientX;

          const differenceY =
            touchStartY - event.changedTouches[0].clientY;

          if (
            Math.abs(differenceX) < 50 ||
            Math.abs(differenceX) <= Math.abs(differenceY)
          ) {
            return;
          }

          if (differenceX > 0) {
            showSlide(currentIndex + 1);
          } else {
            showSlide(currentIndex - 1);
          }

        }, { passive: true });

      }

    }

    /* ===================================
       INITIALIZE
    =================================== */

    showSlide(0);

  };

  /* Initialize galleries already on page */

  document.querySelectorAll(
    '.custom-product-gallery'
  ).forEach(initializeGallery);

  /* Shopify Theme Editor support */

  document.addEventListener(
    'shopify:section:load',
    (event) => {

      event.target.querySelectorAll(
        '.custom-product-gallery'
      ).forEach(initializeGallery);

    }
  );

})();
  } catch(e) { console.error(e); }
})();

})();
